'use strict';

// W3C traceparent is "version-traceid-spanid-flags" (e.g. 00-<32 hex>-<16 hex>-01).
// The backend logs the trace id as the snake_case `trace_id` field on its root spans,
// so parse the same id out of a client-side traceparent to keep both pivotable by one key.
//
// This lives beside the client logger (the viz webpack build aliases @graphistry/common to
// this directory) as a pure-ESM leaf module, so webpack resolves the named exports cleanly.

export function traceIdFromTraceparent(traceparent) {
    if (typeof traceparent !== 'string') {
        return undefined;
    }
    const parts = traceparent.split('-');
    // parts: [version, traceId, spanId, flags]; the all-zero trace id is invalid per W3C.
    // A short/malformed traceparent leaves parts[1] undefined, which the hex test rejects,
    // so no explicit length guard is needed.
    if (/^[0-9a-f]{32}$/.test(parts[1]) && !/^0{32}$/.test(parts[1])) {
        return parts[1];
    }
    return undefined;
}

// Log fields for a client-side traceparent: keep the full traceparent and add the parsed
// trace_id when present, so a client log line correlates to its trace the same way the
// backend root-span logs do. Spread into a log object: logger.info({ ...traceFields(trail) }).
export function traceFields(traceparent) {
    const traceId = traceIdFromTraceparent(traceparent);
    return traceId ? { traceparent, trace_id: traceId } : { traceparent };
}
